module.exports = __webpack_public_path__ + "assets/img/case4.42ae3006.png";